package com.happyukrainian.revision.kweb.pages.routes

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableFloatStateOf
import androidx.compose.runtime.mutableIntStateOf
import androidx.compose.runtime.mutableStateMapOf
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.happyukrainian.revision.kweb.components.FlashcardComponent
import com.happyukrainian.revision.kweb.components.NavigationRail
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.translateX
import com.varabyte.kobweb.silk.components.text.SpanText
import flashcards.FlashCard
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.vw
import kotlin.math.abs

@Composable
fun FlashCardsRoute(
    flashcards: List<FlashCard>,
    compact: Boolean,
) {
    if (flashcards.isEmpty()) {
        SpanText("Loading...")
    } else {
        Flashcards(flashcards, compact)
    }
}

@Composable
private fun Flashcards(
    flashcards: List<FlashCard>,
    compact: Boolean,
) {
    var currentCard by remember { mutableIntStateOf(0) }
    var targetOffset by remember { mutableFloatStateOf(0.0f) }

    val showingQuestion = remember { mutableStateMapOf<FlashCard, Boolean>() }

    val scope = rememberCoroutineScope()
    var uiEnabled by remember { mutableStateOf(true) }

    LaunchedEffect(currentCard) {
        while (abs(targetOffset - (currentCard * 100)) > 0.1) {
            targetOffset += ((currentCard * 100) - targetOffset) / 4
            delay(1000 / 100)
        }
    }

    Column(modifier = Modifier.fillMaxSize(), horizontalAlignment = Alignment.CenterHorizontally) {
        Box(modifier = Modifier.translateX((-targetOffset).vw)) {
            flashcards.forEachIndexed { index, flashCard ->
                FlashcardComponent(
                    flashCard = flashCard,
                    compact = compact,
                    showingQuestion = showingQuestion[flashCard] ?: true,
                    toggleSide = {
                        showingQuestion[it] = !(showingQuestion[it] ?: true)
                    },
                    modifier =
                        Modifier
                            .translateX((100 * index).vw),
                )
            }
        }

        NavigationRail(
            currentCard = currentCard,
            totalCards = flashcards.size - 1,
            onPrevious = {
                if (uiEnabled) {
                    uiEnabled = false
                    scope.launch {
                        currentCard--
                        uiEnabled = true
                    }
                }
            },
            onNext = {
                if (uiEnabled) {
                    uiEnabled = false
                    scope.launch {
                        currentCard++
                        uiEnabled = true
                    }
                }
            },
        )
    }
}
